import React from "react";

export const errorMessage = (error) => <div className="msg-error text-danger">{error}</div>;

export const isEmpty = (obj) => {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
};